import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sempre que o caminho mudar, rola para o topo
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
